const processValue = value => value.content

export default processValue
